import React, {useEffect} from "react"
import Dropzone from "react-dropzone";
import {ParserManager} from "../../../../Shared/Import/ParserManager";
import {ParserType} from "../../../../Shared/Import/ParserType";
import axios from "axios";
import MesureStore from "../../MesureStore";
import socket from "../../../../Shared/socket";
import {RequestState} from "../../../../Shared/StateHelper";
import {toast} from "react-toastify";

const ImportMeasureDropZone = () => {
    const manager = new ParserManager()

    useEffect(() => {
        console.log("Subscribing to socket")
        socket.on("fileDetected", (args) => {
            console.log("File detected from socket:" + args)
            updateData(manager.parseData(args.data.text, ParserType[args.metadata.software]))
        })
    }, []);

    const onDrop = (files) => {
        const pdf = files.find(file => file.type === "application/pdf");
        const images = files.filter(file => file.type.startsWith("image/"));

        manager.parseFile(pdf, ParserType.OPLUS).then(res => updateData(res))
        if(images?.length) uploadMedia(images)
    }


    const updateData = (data) => {
        console.log(data)
        axios.post(`/api/import/appointment/${MesureStore.appointement_id}/parser`, data).then(res => {
            const appointment = res.data.appointment
            if (appointment.anamnesis) MesureStore.anamnesis = appointment.anamnesis
            if (appointment.orthoptic_text) MesureStore.orthoptic_text = appointment.orthoptic_text
            if (appointment.comment_for_ophtalmologist) MesureStore.comment_for_ophtalmologist = appointment.comment_for_ophtalmologist

            const patient = res.data.patient
            if (patient.telephone) MesureStore.patient.telephone = patient.telephone
            if (patient.num_carte_vitale) MesureStore.patient.num_carte_vitale = patient.num_carte_vitale
            if (patient.history) MesureStore.patient.history = patient.history

            MesureStore.loadKindsMesures()
        })
    }

    const uploadMedia = (files) => {
        let formData = new FormData();
        files.forEach(file => {
            if (file.name.includes(".jpg") || file.name.includes(".jpeg") || file.name.includes(".JPG") || file.name.includes(".JPEG") || file.name.includes(".png") || file.name.includes(".PNG")) {
                formData.append(file.name, file, file.name)
            }
        });

        axios.post("/api/uploadImages", formData)
            .then((_) => {
                MesureStore.hasImages()
            }).catch(() => {
            toast.error("Erreur lors de du téléchargement des images")
        })
    }

    return <Dropzone onDrop={onDrop}>
        {({getRootProps, getInputProps, isDragActive}) => {
            return <div {...getRootProps()} className="clickable"
                        title={"Cliquer ou déposer un fichier pdf de mesures ici pour l'importer"}
                        style={{
                            height: 50,
                            width: 50,
                            display: "flex",
                            backgroundColor: isDragActive ? "lightgrey" : "white",
                            justifyContent: "center",
                            alignItems: "center",
                            border: "thin solid #dddddd",
                            borderRadius: 10
                        }}>
                <input {...getInputProps()} />
                <label>OPLUS</label>
            </div>
        }}
    </Dropzone>
}

export default ImportMeasureDropZone